module.exports = __webpack_public_path__ + "static/media/i5.19508f4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i5.svg
// module id = 200
// module chunks = 8